import { call, put } from 'redux-saga/effects';
import { getErrorMessage } from '../../services/Errors';
import ConfigActions from '../actions/ConfigActions';
import { callApi } from './Api';

const { getConfigSuccess, getConfigFailure } = ConfigActions;

export function* getConfiguration(api) {
  const response = yield call(callApi, api, 'getConfiguration');
  if (response.ok) {
    yield put(getConfigSuccess(response.data));
  } else {
    yield put(
      getConfigFailure(
        getErrorMessage(response, 'Could not load configurations.')
      )
    );
  }
}



// WEBPACK FOOTER //
// ./src/state/sagas/ConfigSagas.js